import {
  RecurringFee,
  RecurringFeeTypes,
} from 'components/billing/common/types';
import { useGetRecurringFees } from 'components/billing/context/useBilling';
import { isEndDateBeforeStartDate, isStartDateInFuture } from '../helpers';

export const useProductTrialStatus = (
  feeType: RecurringFeeTypes,
  planId?: number,
) => {
  const { data: feeData, isFetched: feeDataFetched } = useGetRecurringFees({
    type__eq: feeType.toString(),
    product_plan_id__eq: planId,
  });

  if (!feeDataFetched || !feeData?.length) {
    return {
      onProductFreeTrial: false,
      hasExpiredProductFreeTrial: false,
    };
  }

  const hasExpiredProductFreeTrial = feeData.some((fee) => {
    return isEndDateBeforeStartDate(fee.endDate, fee.startDate);
  });

  // Exclude soft-deleted fees
  const validFees = feeData.filter(
    (fee) => !isEndDateBeforeStartDate(fee.endDate, fee.startDate),
  );

  // Only fees that will be charged in the future
  const onProductFreeTrial = Boolean(
    validFees.length &&
      validFees.every((fee) => isStartDateInFuture(fee.startDate)),
  );

  const trialPlatformFee = validFees
    .filter((fee: RecurringFee) => {
      return isStartDateInFuture(fee.startDate);
    })
    .sort((a: RecurringFee, b: RecurringFee) => {
      return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
    })[0];

  const trialEndDate = trialPlatformFee?.startDate;
  const trialProductPlanId = trialPlatformFee?.productPlanId;
  const trialPlatformFeeAmount = trialPlatformFee?.amountCents;

  return {
    onProductFreeTrial,
    hasExpiredProductFreeTrial,
    trialEndDate: trialEndDate || null,
    trialProductPlanId,
    trialPlatformFeeAmount,
  };
};
